<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('news-panel')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add News</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
        >
        </base-input>

        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />
        (Dimensions should H-700, W-900)
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
        <img v-if="image" :src="image" ref="cover" />
        <!-- <quill-editor
          v-model="body"
          :options="editorOption"
          class="quill-h200px my-2"
        /> -->

        <!-- <b-form-group id="input-group-3" label="Tags:" label-for="input-3">
          <b-form-select id="input-3" v-model="selectedtag" required>
            <b-form-select-option :value="null" disabled
              >-- Please select an Tags --</b-form-select-option
            >
            <b-form-select-option
              v-for="(tag, indexOpt) in tags"
              :value="tag._id"
              :key="indexOpt"
              >{{ tag.name }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group> -->
        <div class="py-4 customboxed">
          <p class="mb-1">News Link</p>
          <base-input
            class="mb-3"
            name="Link"
            :rules="{ required: true }"
            placeholder="Add your news link"
            v-model="link"
          >
          </base-input>
          <span v-if="linkErr" class="small text-danger">{{ msg.link }}</span>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      title: "",
      link: "",
      image: null,
      coverImage: null,
      body: "",
      selectedpageCategory: "",
      editorOption: {
        theme: "snow",
      },
      imageErr: false,
      linkErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("cms", {
      pageCategories: "pageCategories",
      selectedpagecategory: "selectedpagecategory",
    }),
  },
  methods: {
    handleSuccess(image) {
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        let mByte = 5 * 1048576;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      this.pageCategories.forEach((x) => {
        if (x.name == "News") this.selectedpageCategory = x._id;
      });

      data.append("type", "single");
      data.append("title", this.title);
      data.append("subTitle", "");
      data.append("media", this.coverImage);
      data.append("html", this.body);
      data.append("link", this.link);
      data.append("pageCategory", this.selectedpageCategory);
      // data.append("tags", JSON.stringify(""));

      let loader = this.$loading();

      if (!this.coverImage) {
        this.$swal.fire({
          text: "Please Select Image",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        loader.close();
        return;
      }

      try {
        const pattern = /^(https?|http?):\/\/[^\s$.?#].[^\s]*$/gm;
        if (!pattern.test(this.link)) {
          this.linkErr = true;
          this.msg.link = "Enter a valid url";
        } else {
          const newsdata = await this.$store.dispatch("cms/addPage", data);

          if (newsdata.code == 200) {
            this.$router.push({ name: "news-panel" });
            this.$swal.fire({
              text: "News Added Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
